import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './logoAniMemo192.png'


const _hoisted_1 = { class: "fixed top-0 left-0 flex flex-row border-b-2 border justify-between h-12 w-full bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center h-full rounded-md hover:bg-gray-600 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo animemo",
    class: "object-contain w-8 h-8 hover:cursor-pointer"
  }),
  /*#__PURE__*/_createElementVNode("h2", { class: "ml-5 text-2xl text-white" }, " Admin AniMemo ")
], -1)
const _hoisted_3 = { class: "flex flex-row items-center h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: "",
        alt: "",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onKlikProfil && _ctx.onKlikProfil(...args))),
        class: "w-8 h-8 object-contain cursor-pointer"
      })
    ])
  ]))
}